import MasterTable from "../../views/dashboard/widget/MasterTabel";
import { useGlobalState } from "../../services/hostelConst.js";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getAcademicYearList,
  addAcademicYear,
  updateAcademicYear,
  deleteAcademicYear,
  updateAcademicYearStatus,
} from "../../services/Academic-Services";
import AddClassesForm from "../../components/FormComponents/AddClasses.js";
import AddAcademicYearForm from "../../components/FormComponents/AddAcademicYear.js";

const AcademicYearTable = () => {
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
  } = useGlobalState();
  useEffect(() => {
    resetAdvanceFilterData();
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });

    return () => {};
  }, []);

  return (
    <>
      <MasterTable
        getTableData={getAcademicYearList}
        deleteRow={deleteAcademicYear}
        updateStatus={updateAcademicYearStatus}
        AddForm={AddAcademicYearForm}
        tab1={"Academic"}
        tab2={"Academic Year"}
        actions={{
          status: true,
          edit: true,
          delete: true,
        }}
      />
    </>
  );
};

export default AcademicYearTable;
